import { Controller } from "@hotwired/stimulus";

// A freshly-attached media thumbnail's variant is generated on-demand the first
// time it is viewed; during that window the representation URL 404s (see the
// ActiveStorage redirect guard). Browsers don't retry a broken <img>, so re-request
// the URL until the variant finishes generating, then it swaps itself in.
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 250 },
    maxAttempts: { type: Number, default: 20 },
  };

  connect() {
    this.attempts = 0;
    this.baseSrc = this.element.getAttribute("src");
    // The <img> can error before this controller connects (a fast 404), so the
    // error action never fires -- kick off the first retry from here in that case.
    if (this.element.complete && this.element.naturalWidth === 0) {
      this.scheduleRetry();
    }
  }

  disconnect() {
    this.cancel();
  }

  retry() {
    this.scheduleRetry();
  }

  loaded() {
    this.cancel();
  }

  scheduleRetry() {
    if (this.timer || this.attempts >= this.maxAttemptsValue) return;

    this.timer = setTimeout(() => {
      this.timer = null;
      this.attempts += 1;
      // Cache-bust so the browser actually re-requests; the representation route
      // ignores the extra param (its signed data lives in the path).
      const separator = this.baseSrc.includes("?") ? "&" : "?";
      this.element.src = `${this.baseSrc}${separator}retry=${this.attempts}`;
    }, this.intervalValue);
  }

  cancel() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
